import React, { useEffect } from "react";
import { useState } from "react";
import { isLoggedIn } from "../../Hooks/isLoggedIn";
import "./UserComment.css";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import ImageNotFound from "../../Assets/images/userDefault.jpg";
import { MdDeleteForever } from "react-icons/md";

export default function UserComment({ itemId }) {
    const [showTextArea, setShowTextArea] = useState(false);
    const [commentList, setCommentList] = useState();
    const [comment, setComment] = useState({
        text: "",
        itemId: itemId,
        parentId: null,
    });
    function getComments() {
        axiosConfig.get("api/comments/" + itemId).then((res) => {
            setCommentList(res.data);
        });
    }

    useEffect(() => {
        setComment({ ...comment, itemId: itemId });
        if (itemId != null && itemId !== "") getComments();
    }, [itemId]);

    const handleShowTextArea = (itemId, index) => {
        setComment({ ...comment, parentId: itemId });
        setShowTextArea(index);
    };

    function deleteComment(id) {
        axiosConfig
            .delete("api/comments/" + id)
            .then((res) => {
                toast.success("با موفقیت کامنت حذف شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                getComments();
            })
            .catch((err) => {
                toast.error("در هنگام ثبت مشکلی پیش اومد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            });
    }

    function sendComment(isParentIdNull) {
        if (isParentIdNull) comment.parentId = null;
        if (comment.text == "") {
            toast.warning("لطفا متن خود را وارد کنید", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            axiosConfig
                .post("api/comments", comment)
                .then((res) => {
                    toast.success("با موفقیت کامنت اضافه شد", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    getComments();
                })
                .catch((err) => {
                    toast.error("در هنگام ثبت مشکلی پیش اومد", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                });

            setShowTextArea(null)
        }
    }

    return (
        <>
            <div className="user-comment">
                <div className="user-comment-content">
                    <div className="user-comment-textarea-header">
                        <h1>نقد و بررسی ها</h1>
                    </div>
                    {commentList
                        ?.filter((p) => p.parentId == null)
                        .map((item, index) => (
                            <div className="user-comments" key={index}>
                                <div className="user-comment-wrapper">
                                    <div className="user-comment-user">
                                        <div className="user-comment-user-image">
                                            {item.registererUser.profileImage !=
                                                null ? (
                                                <img
                                                    src={
                                                        axiosConfig.defaults
                                                            .baseURL +
                                                        "Images/UserImage/" +
                                                        item.registererId +
                                                        "/" +
                                                        item.registererUser
                                                            .profileImage
                                                    }
                                                    alt={`نظر ${item.registererUser.userName}`}
                                                />
                                            ) : (
                                                <img
                                                    src={ImageNotFound}
                                                    alt={`نظر ${item.registererUser.userName}`}
                                                />
                                            )}
                                            <h3>
                                                {item.registererUser.userName}
                                            </h3>
                                            <div>کاربر</div>
                                            {
                                                item.registererId == localStorage.getItem("userId") ? (
                                                    <MdDeleteForever title="حذف" onClick={() => deleteComment(item.id)} />
                                                ) : (<></>)
                                            }
                                        </div>
                                        <div>
                                            {new Date(
                                                item.registerDate
                                            ).toLocaleDateString("fa-IR")}
                                        </div>
                                    </div>
                                </div>
                                <div className="user-comment-text">
                                    {item.text}
                                    <span
                                        onClick={() =>
                                            handleShowTextArea(item.id, index)
                                        }
                                    >
                                        پاسخ
                                    </span>
                                </div>
                                {showTextArea === index ? (
                                    <div className="user-comment-textarea">
                                        <div className="user-comment-textarea-header">
                                            <h1>دیدگاهتان را بنویسید</h1>
                                        </div>
                                        <div className="user-comment-textarea-input">
                                            <textarea
                                                rows="2"
                                                cols=""
                                                id="commentText"
                                                onChange={(e) =>
                                                    setComment({
                                                        ...comment,
                                                        text: e.target.value,
                                                    })
                                                }
                                            ></textarea>
                                            <button
                                                onClick={() =>
                                                    sendComment(false)
                                                }
                                            >
                                                فرستادن دیدگاه
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}
                                {commentList
                                    ?.filter((p) => p.parentId == item.id)
                                    ?.map((replay,indexx) => (
                                        <div className="user-comments-replay" key={indexx}>
                                            <div className="user-comment-wrapper">
                                                <div className="user-comment-user">
                                                    <div className="user-comment-user-image">
                                                        {replay.registererUser
                                                            .profileImage !=
                                                            null ? (
                                                            <img
                                                                src={
                                                                    axiosConfig
                                                                        .defaults
                                                                        .baseURL +
                                                                    "Images/UserImage/" +
                                                                    replay.registererId +
                                                                    "/" +
                                                                    replay
                                                                        .registererUser
                                                                        .profileImage
                                                                }
                                                    alt={`نظر ${replay.registererUser.userName}`}
                                                            />
                                                        ) : (
                                                            <img
                                                                src={
                                                                    ImageNotFound
                                                                }
                                                    alt={`نظر ${replay.registererUser.userName}`}
                                                            />
                                                        )}
                                                        <h3>
                                                            {
                                                                replay
                                                                    .registererUser
                                                                    .userName
                                                            }
                                                        </h3>
                                                        <div>کاربر</div>
                                                        {
                                                            replay.registererId == localStorage.getItem("userId") ? (
                                                                <MdDeleteForever title="حذف" onClick={() => deleteComment(replay.id)} />
                                                            ) : (<></>)
                                                        }
                                                    </div>
                                                    <div>
                                                        {new Date(
                                                            replay.registerDate
                                                        ).toLocaleDateString(
                                                            "fa-IR"
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="user-comment-text">
                                                {replay.text}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        ))}
                </div>
            </div>

            <div className="user-comment-textarea">
                <div className="user-comment-textarea-header">
                    <h1>دیدگاهتان را بنویسید</h1>
                </div>
                <div className="user-comment-textarea-input">
                    {isLoggedIn() == true ? (
                        <>
                            <textarea
                                rows="4"
                                cols=""
                                id="commentText"
                                onChange={(e) =>
                                    setComment({
                                        ...comment,
                                        text: e.target.value,
                                    })
                                }
                            ></textarea>
                            <button onClick={() => sendComment(true)}>
                                فرستادن دیدگاه
                            </button>
                        </>
                    ) : (
                        <button>لطفا برای ثبت نظر وارد حسابتان شوید</button>
                    )}
                </div>
            </div>
            <ToastContainer />
        </>
    );
}
